import { AxiosRequestConfig } from 'axios';

interface ReportConfig extends AxiosRequestConfig {
  method: 'GET';
  params: { classId?: string };
  url: `/student_in_classes/${string}/report`;
}

interface StudentReportPoints {
  assignment: number;
  mixedReview: number;
}

interface StudentReportPercentages {
  accuracy: number;
  activeSkillsAccuracy: number;
}

export interface StudentReportSkill {
  id: string;
  active: boolean;
  attempts: number;
  color: StudentReportSkillColor;
  currentlyWrong: boolean;
  currentPenalties: number;
  dateAdded: string;
  description: string;
  lastCorrect: string | null;
  percentages: StudentReportSkillPercentages;
  studentActive: boolean;
}

export enum StudentReportSkillColor {
  untried = 'untried',
  notEnoughData = 'not enough data',
  red = 'red',
  yellow = 'yellow',
  green = 'green',
  silver = 'silver',
  gold = 'gold',
}

interface StudentReportSkillPercentages {
  accuracy: number;
  lastFive: number;
}

export interface StudentInKlassesReportResponse {
  firstName: string;
  lastName: string;
  isInIndividualMixedReview: boolean;
  username: string;
  studentInClassId: string;
  attempts: number;
  errorsFixed: number;
  rotationTime: number;
  unfixedErrors: number;
  currentPenalties: number;
  points: StudentReportPoints;
  percentages: StudentReportPercentages;
  skills: StudentReportSkill[];
  pointsEarned: number;
}

/**
 * GET /api/v2/student_in_classes/{id}/report
 */
export const report = (
  studentInClassId: string,
  classId?: string,
): ReportConfig => {
  return {
    method: 'GET',
    params: { classId },
    url: `/student_in_classes/${studentInClassId}/report`,
  } as const;
};
